import { defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'TabsPlain',
    inheritAttrs: false,
    props: {
        tabs: {
            required: true,
            type: Array,
        },
        currentTab: {
            required: true,
            type: Object,
        },
        view: {
            default: 'plain',
            type: String,
            validator(value) {
                return ['plain', 'panel'].includes(value);
            },
        },
    },
    setup(_, { emit }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        function changeTab(tab) {
            emit('change', tab);
        }
        return {
            css,
            changeTab,
        };
    },
});
